import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MAIN_DOMAIN } from '@crt/sui';
import { finalize } from 'rxjs/operators';

import { MessageService } from '@app/messages/message.service';
import { EnvironmentService } from '@app/shared/environment.service';
import { XsrfService } from '@app/shared/xsrf.service';

export const xsrfInterceptor: HttpInterceptorFn = (req, next) => {
  const environmentService = inject(EnvironmentService);
  const xsrfService = inject(XsrfService);
  const messageService = inject(MessageService);

  let request = req;

  if (environmentService.hostname.endsWith(MAIN_DOMAIN)) {
    request = request.clone({
      setHeaders: { 'X-XSRF-TOKEN': xsrfService.token },
      withCredentials: true,
    });
  }

  if (request.params.has('polling') || request.headers.has('x-hide-loader')) {
    return next(
      request.clone({
        headers: request.headers.delete('x-hide-loader'),
      }),
    );
  }

  messageService.showLoading = true;

  return next(request).pipe(
    finalize(() => {
      messageService.showLoading = false;
    }),
  );
};
